"use strict";
import Immutable from "immutable";
import { List, Record, Map } from "immutable";
import Get from "./get";
const CachedItem = Record({
  item: null,
  fetchedAt: null
});
const isNeed = (object) => object && (object.__type__ === "need" || object.__type__ === "needCollection");
const Need = Immutable.Record({
  "__type__": "need",
  "address": null
});
const getItem = (cache, cacheAddress, timestamp = 0) => {
  const id = _.last(cacheAddress);
  if (id === null || id === void 0) {
    return null;
  } else if (isNeed(id)) {
    const need = id;
    return need;
  } else if (cache.data.hasIn(cacheAddress)) {
    const cacheItem = cache.data.getIn(cacheAddress);
    if (cacheItem.fetchedAt > timestamp) {
      return cacheItem.item;
    } else {
      return Need({
        address: List(cacheAddress)
      });
    }
  } else {
    return Need({
      address: List(cacheAddress)
    });
  }
};
const getRangedCollection = (cache, baseAddress, range, timestamp = 0) => {
  const count = getItem(cache, baseAddress.concat(["count"]), timestamp);
  if (isNeed(count)) {
    if (range === "count") {
      return count;
    } else {
      return Get.map(range, (index) => {
        return getItem(cache, baseAddress.concat([index]), timestamp);
      });
    }
  } else {
    if (range === "count") {
      return count;
    } else {
      const actualRange = Immutable.Range(0, Math.min(count, range.last()));
      return Get.map(actualRange, (index) => {
        return getItem(cache, baseAddress.concat([index]), timestamp);
      });
    }
  }
};
const notInExistingRequests = (requests) => (need) => !requests.find((needs) => needs.includes(need));
export default {
  getItem,
  getRangedCollection,
  isNeed,
  fetchNeeds(component, configuration, cache, needs) {
    const needCollections = needs.filter((need) => need.get("__type__") === "needCollection");
    const basicNeeds = needs.filter((need) => need.get("__type__") === "need");
    const newNeed = notInExistingRequests(cache.requests);
    const allNeeds = needCollections.flatMap((need) => {
      const list = need.get("needs");
      return list.flatMap((x) => {
        if (x.get("__type__") === "needCollection") {
          return x.get("needs");
        } else {
          return List.of(x);
        }
      });
    }).concat(basicNeeds).filter(newNeed);
    const groupedNeeds = allNeeds.groupBy(
      (need) => configuration.getIn(["requestGroups", need.getIn(["address", 0])])
    );
    const groupRequestIds = groupedNeeds.map(
      (value, key, index) => cache.lastRequestId + index + 1
    );
    const newCache = groupedNeeds.reduce((currentCache, needs2, group) => {
      const requestId = groupRequestIds.get(group);
      return currentCache.set("lastRequestId", requestId).setIn(["requests", requestId], needs2);
    }, cache);
    groupedNeeds.forEach((needs2, group) => {
      $.ajax({
        url: configuration.get("apiEndpoint"),
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          needs: needs2.map((need) => need.get("address")).toJS()
        })
      }).then((data) => {
        const results = Immutable.fromJS(data);
        const currentCache = component.state.app.cache;
        const newCacheData = this.updatedCacheData(results.get("graph") || results, configuration, currentCache);
        component.cacheUpdated(currentCache.set("data", newCacheData).deleteIn(["requests", groupRequestIds.get(group)]));
      });
    });
    return newCache;
  },
  updatedCacheData(results, configuration, currentCache) {
    const timestamp = Date.now();
    return results.reduce((newData, values, entityType) => {
      if (configuration.get("collections").includes(entityType)) {
        return newData.set(entityType, CachedItem({
          fetchedAt: timestamp,
          item: values
        }));
      }
      if (configuration.get("rangedCollections").includes(entityType)) {
        return newData.set(
          entityType,
          values.reduce((newEntities, [key, value]) => {
            return newEntities.setIn(key.toJS(), CachedItem({
              fetchedAt: timestamp,
              item: value
            }));
          }, newData.get(entityType))
        );
      } else {
        return newData.set(
          entityType,
          values.reduce((newEntities, [id, value]) => {
            const item = Map.isMap(value) ? Record(value.toObject())({}) : value;
            return newEntities.set(Immutable.fromJS(id), CachedItem({
              fetchedAt: timestamp,
              item
            }));
          }, newData.get(entityType))
        );
      }
    }, currentCache.data);
  }
};
